import { IPackagingRemittanceComplianceData } from '@nkr/models/index';
import { PackagingRemittance } from '@nkr/enums/index';

interface IProps {
    centerId: number,
    packagingRemittance: IPackagingRemittanceComplianceData,
}

const PackagingRemittanceOverlay = (props: IProps) => {
    const value = props.packagingRemittance != null ? props.packagingRemittance.complianceValue : PackagingRemittance.Unknown;

    return (
        <div className='custom-popover right'>
            <div className='arrow'></div>

            {value == PackagingRemittance.NotSpecified && (
                <>
                    <div style={{ marginBottom: 5 }}>You must specify how you would like to do organ packaging.</div>
                    <div>To update your profile, <a href={`/center/${props.centerId}/profile/edit/packaging`} target='_blank'>click here</a>.</div>
                </>
            )}

            {value == PackagingRemittance.InhouseMissingAch && (
                <>
                    <div style={{ marginBottom: 5 }}>You have selected to do your packaging in-house.</div>
                    <div style={{ marginBottom: 5 }}>Unfortunately, we are missing required information.</div>
                    <div>To update your profile, <a href={`/center/${props.centerId}/profile/edit/packaging`} target='_blank'>click here</a>.</div>
                </>
            )}

            {value == PackagingRemittance.OpoNotSpecified && (
                <>
                    <div style={{ marginBottom: 5 }}>You have selected to do your packaging using an OPO but one was not selected.</div>
                    <div>To select an OPO, <a href={`/center/${props.centerId}/profile/edit/packaging`} target='_blank'>click here</a>.</div>
                </>
            )}
        </div>
    );
}

export default PackagingRemittanceOverlay;